<template>
  <section class="registered-courses-page-container">
    <b-container class="my-4">
      <b-row>
        <b-col md="12">
          <div class="header">
            <h4 class="text-brand text-center">المواد المسجلة</h4>
          </div>
        </b-col>
        <b-col md="12">
          <div v-for="(course, index) in data" :key="index" class="content">
            <b-row>
              <b-col lg="6" md="12" sm="12" class="d-flex align-items-center justify-content-center">
                <div class="course-specifications">
                  <div>
                    <h3 class="course-title">{{ course.name }}</h3>
                    <b-row>
                      <b-col cols="12">
                        <i class="fa fa-money mx-1"></i> السعر: <strong>{{ course.price + ' ' + (course.currency ==
                          'EGP' ? 'جنيه مصري' : 'ريال سعودي') }}</strong>
                      </b-col>
                      <b-col cols="12">
                        <i class="fa fa-clock-o mx-1"></i> عدد الساعات: <strong>{{ course.hours_count }} ساعة</strong>
                      </b-col>
                      <b-col cols="12">
                        <i class="fa fa-calendar mx-1"></i> تاريخ الدورة: <strong>{{ course.start_date }}</strong>
                      </b-col>
                      <!-- <b-col cols="12">
                      <i class="fa fa-list mx-1"></i> مدة الدورة بالأيام: <strong>{{ course.duration }}</strong>
                    </b-col> -->
                    </b-row>
                  </div>
                </div>
              </b-col>
              <b-col lg="6" md="12" sm="12">
                <img width="100%" :src="course.image || placeholderImage" :alt="course.name" class="course-image"
                  style="height: 250px; ">
              </b-col>
              <b-col cols="12">
                <div class="course-details">
                  <p class="course-details-description">{{ course.description }}</p>
                </div>
              </b-col>

              <b-col cols="12" class="text-center mt-5">
                <b-button @click="goToRoute('courseContent', course.id)" aria-label="الدخول الى المادة"
                  variant="brand"> الدخول الى المادة</b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { sendRequest } from "../utils/RequestHelper.js";
import placeholderImg from '@/assets/images/placeholder.png';
import store from "../store/index.js";

export default {
  name: 'myCourses',
  data() {
    return {
      placeholderImg,
      data: [],
      pageIsLoading: false,

    };
  },
  methods: {
    goToRoute(route, id) {
      this.$router.push({ name: route, params: { id }, query: { isReg: true } });
    },
    goToLink(link) {
      window.open(link, "_blank");
    },
    loadData() {
      this.pageIsLoading = true;
      sendRequest('get', 'users/student/courses/', true, null,
        (data) => {
          this.data = data;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
    },
  },
  watch: {
    $route(to, from) {
      this.username = this.$store.getters.username;
    },
  },
  created() {
    if (store.getters.authToken) {
      this.loadData();
    } else {
      this.$router.push({ name: 'login' })
    }
  }
};
</script>

<style scoped>
.registered-courses-page-container {
  background-color: rgb(236, 236, 236) !important;
}

h4 {
  margin-bottom: 0;
  font-size: 32px;
  font-weight: bold;
}

.registered-courses-page-container .header,
.registered-courses-page-container .content {
  background-color: white !important;
  border-radius: 30px;
  padding: 10px 30px;
  margin-bottom: 20px;
}

.registered-courses-page-container .header {
  font-weight: bold;
  margin-bottom: 20px !important;
}

.registered-courses-page-container .content p {
  text-align: justify;
  font-size: 20px;
}

.course-image {
  height: 150px;
  object-fit: contain;
  border-radius: 10px;
}

.course-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}

.course-details {
  font-size: 16px;
  margin-top: 25px;
}

.course-specifications {
  font-size: 18px;
}

/* mobile */
@media (max-width: 575.98px) {
  h4 {
    font-size: 24px;
  }

  .course-title {
    font-size: 22px;
  }

  .registered-courses-page-container .header,
  .registered-courses-page-container .content {
    border-radius: 20px;
    padding: 12px 16px;
  }

  .registered-courses-page-container .content p {
    /* justify leaves large gaps on narrow lines */
    text-align: start;
    font-size: 17px;
  }

  .course-specifications {
    font-size: 16px;
  }
}
</style>
